'use client';
import expand from '@/assets/images/convention/Expand.svg';
import customization from '@/assets/images/convention/virtual/Customization.jpg';
import productfitting from '@/assets/images/convention/virtual/ProductFitting.jpg';
import shopping from '@/assets/images/convention/virtual/Shopping.jpg';
import banner1 from '@/assets/images/convention/virtual/virtualappointments.jpg';
import banner1_m from '@/assets/images/convention/virtual/virtualappointments_m.jpg';
import { websiteEnv } from '@/constants/website-env';
import useIsMobile from '@/hooks/use-is-mobile';
import { BrowserPersistence } from '@/util';
import Image from 'next/image';
import { useCallback, useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import CancelDialog from './cancelDialog';
import InformationForm from './informationForm';
import InquiryAppointment from './inquiryAppointment';
import { useVirtualAppointments } from './useVirtualAppointments';
import classes from './virtualAppointments.module.css';
const storage = new BrowserPersistence();

export const VirtualAppointments = () => {
  const timezoneselect = useRef(null);
  const [formData, setFormData] = useState();
  const [formDataId, setFormDataId] = useState(null);
  const isMobile = useIsMobile();
  const pageTitle = 'VIRTUAL APPOINTMENTS';

  const talonProps = useVirtualAppointments(timezoneselect);
  const {
    handleChange,
    changeDate,
    isActive,
    appointmentData,
    SelectVirType,
    virType,
    changeTime,
    completeStep1,
    completeStep2,
    setCompleteStep1,
    setCompleteStep2,
    getweek,
    getdate,
    getweektip,
    monthlist,
    reelect,
    timezonedata,
    timeDiff,
    setIsUpdate,
    isUpdate,
    error,
    canCelSubmit,
    canCelhandle,
    response,
    canceldialog,
  } = talonProps;

  const queryParams = new URLSearchParams(window.location.search);
  const id = queryParams.get('id');
  const email = queryParams.get('email');

  useEffect(() => {
    if (id && email) {
      setCompleteStep1(true);
      setCompleteStep2(true);
    }
  }, [setCompleteStep1, setCompleteStep2]);

  const updateSubmit = useCallback(
    id => {
      setFormDataId(id);
      setIsUpdate(true);
      storage.setItem('formData', JSON.stringify(formData));
      setCompleteStep1(false);
      setCompleteStep2(false);
    },
    [formData, setCompleteStep1, setCompleteStep2, setIsUpdate],
  );

  const timelist = {
    Monday: [
      '7:00',
      '7:30',
      '8:00',
      '8:30',
      '9:00',
      '9:30',
      '10:00',
      '10:30',
      '14:00',
      '14:30',
      '15:00',
      '17:00',
      '17:30',
      '18:00',
      '18:30',
      '19:00',
      '19:30',
      '20:00',
      '20:30',
      '21:00',
    ],
    Tuesday: [
      '7:00',
      '7:30',
      '8:00',
      '8:30',
      '9:00',
      '9:30',
      '10:00',
      '10:30',
      '14:00',
      '14:30',
      '15:00',
      '17:00',
      '17:30',
      '18:00',
      '18:30',
      '19:00',
      '19:30',
      '20:00',
      '20:30',
      '21:00',
    ],
    Wednesday: [
      '7:00',
      '7:30',
      '8:00',
      '8:30',
      '9:00',
      '9:30',
      '10:00',
      '10:30',
      '14:00',
      '14:30',
      '15:00',
      '17:00',
      '17:30',
      '18:00',
      '18:30',
      '19:00',
      '19:30',
      '20:00',
      '20:30',
      '21:00',
    ],
    Thursday: [
      '7:00',
      '7:30',
      '8:00',
      '8:30',
      '9:00',
      '9:30',
      '10:00',
      '10:30',
      '14:00',
      '14:30',
      '15:00',
      '17:00',
      '17:30',
      '18:00',
      '18:30',
      '19:00',
      '19:30',
      '20:00',
      '20:30',
      '21:00',
    ],
    Friday: ['8:30', '9:00', '9:30', '10:00', '10:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00'],
    Saturday: ['10:00', '10:30', '18:00', '18:30', '19:00', '19:30', '20:00'],
    Sunday: ['10:00', '10:30', '18:00', '18:30', '19:00', '19:30', '20:00'],
  };

  const booknowoptions = [
    {
      title: 'Size & Product Fitting',
      con: 'Before your appointment, please measure your size. We will recommend the best fit and styles for you.',
    },
    {
      title: 'Style Customization',
      con: `Before your appointment, please send a picture of your desired style to service@cs.awbridal.com. We will discuss and ${websiteEnv.isUnitedKingdom ? 'customise' : 'customize'} the dress style for you.`,
    },
    {
      title: 'Group Shopping',
      con: 'Book a virtual group fitting to meet with our fit expert. Learn about our products and find the perfect fit for everyone.',
    },
  ];

  useEffect(() => {
    if (response?.code == '200' && response?.message == 'success') {
      window.location.reload();
    }
  }, [response]);

  const allcount = 30;
  let pagecount = 7;

  if (isMobile) {
    pagecount = 3;
  }

  function DayModule(groupid) {
    return (
      <div>
        {[...Array(allcount)].map((item, index) =>
          index + 1 <= groupid.groupid * pagecount && index + 1 > (groupid.groupid - 1) * pagecount ? (
            <div
              className={[classes.dateweek, index == isActive ? classes.active : null].join(' ')}
              onClick={() =>
                changeDate(
                  index,
                  getweek(getdate(Number(index) + 1)),
                  monthlist[getdate(Number(index) + 1).getMonth()] + ' ' + getdate(Number(index) + 1).getDate(),
                )
              }
              key={index}
            >
              {index == 0 ? (
                <label className={classes.acrossweek}>Tomorrow</label>
              ) : (
                <label className={classes.acrossweek}>{getweektip(getweek(getdate(Number(index) + 1)), index)}</label>
              )}
              <span className={classes.w}>{getweek(getdate(Number(index) + 1))}</span>
              <span className={classes.d}>
                {monthlist[getdate(Number(index) + 1).getMonth()]}
                &nbsp;
                {getdate(Number(index) + 1).getDate()}
              </span>
            </div>
          ) : null,
        )}
      </div>
    );
  }

  const groupDayModul = [...Array(Math.ceil(allcount / pagecount))].map((item, index) => (
    <DayModule
      groupid={index + 1}
      key={index}
    />
  ));
  const sliderProps = {
    dots: false,
    infinite: false,
    showArrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <button type='button'>More Times</button>,
    prevArrow: <button type='button'>Previous</button>,
  };
  const datetimeModule = (
    <div className={classes.content}>
      <p className={classes.contenttitle}>Your Time Zone</p>
      <select
        ref={timezoneselect}
        onChange={handleChange}
        className={classes.selecttimezone}
        value={appointmentData.timezone}
      >
        {timezonedata.map(item => {
          return (
            <option
              key={item.value}
              value={item.value}
            >
              {item.label}
            </option>
          );
        })}
      </select>
      <div className={classes.datelist}>
        <Slider {...sliderProps}>{groupDayModul}</Slider>
      </div>
      <div className={classes.timelist}>
        {timelist[getweek(getdate(Number(isActive) + 1))].map((item, index) => (
          <div
            key={index}
            className={classes.timeitem}
            onClick={() => changeTime(Number(item.split(':')[0]) + timeDiff + ':' + item.split(':')[1])}
          >
            <span className={classes.timeinfo}>{Number(item.split(':')[0]) + timeDiff + ':' + item.split(':')[1]}</span>
            <span className={classes.timeinfo}>Continue</span>
          </div>
        ))}
      </div>
    </div>
  );
  const helpyouinfo = [
    {
      img: productfitting,
      title: 'Size & Product Fitting',
      con: 'Consult with our product expert to find the best size for you!',
    },
    {
      img: customization,
      title: 'Style Customization',
      con: `Can't find your ${websiteEnv.isUnitedKingdom ? 'favourite' : 'favorite'} style on our website? Discuss with us to ${websiteEnv.isUnitedKingdom ? 'customise' : 'customize'} the style you want.`,
    },
    {
      img: shopping,
      title: 'Group Shopping',
      con: 'Invite your bridesmaids to discuss with us, and we will recommend the best products and sizes for you.',
    },
  ];
  const helpyouSliderProps = {
    dots: false,
    infinite: false,
    showArrows: false,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow className={'nextarrow'} />,
    prevArrow: <SamplePrevArrow className={'prevarrow'} />,
  };

  function SampleNextArrow(props) {
    const { className, onClick } = props;

    return (
      <span
        className={className}
        onClick={onClick}
      >
        <Image
          className={classes.nextarrow}
          src={expand}
          alt=''
        />
      </span>
    );
  }

  function SamplePrevArrow(props) {
    const { className, onClick } = props;

    return (
      <span
        className={className}
        onClick={onClick}
      >
        <Image
          className={classes.prevarrow}
          src={expand}
          alt=''
        />
      </span>
    );
  }

  const helpyoucon = helpyouinfo.map((item, index) => (
    <div
      className={classes.helpstep}
      key={index}
    >
      <Image
        src={item.img}
        alt=''
      />
      <p className={classes.helpsteptitle}>
        {item.title === 'Style Customization' && websiteEnv.isUnitedKingdom ? 'Style Customisation' : item.title}
      </p>
      <p className={classes.helpstepcon}>{item.con}</p>
    </div>
  ));

  return (
    <div className={classes.virtualappointments}>
      <Image
        className={classes.banner}
        src={isMobile ? banner1_m : banner1}
        alt=''
      />
      <h1 className={classes.title}>{pageTitle}</h1>
      <div className={classes.prespe}>
        <h1 className={classes.prespetitle}>We are here to help you !</h1>
        <div className={classes.helpyou}>
          {isMobile ? <Slider {...helpyouSliderProps}>{helpyoucon}</Slider> : helpyoucon}
        </div>
        <div className={classes.booknow}>
          <h1 className={classes.booknowtitle}>Book Now</h1>
          <div className={classes.booknowcon}>
            <div
              className={[classes.step, completeStep1 && !completeStep2 ? classes.reelect : null].join(' ')}
              onClick={completeStep1 && !completeStep2 ? reelect : null}
            >
              <h5 className={classes.steptitle}>
                <i>1</i>
                <span>Choose Appointment</span>
              </h5>
              {!completeStep1 ? (
                <div className={classes.options}>
                  {booknowoptions.map((item, optionindex) =>
                    virType == optionindex || virType == -1 ? (
                      <div
                        className={[classes.option, virType == optionindex ? classes.activeoption : null].join(' ')}
                        onClick={() => SelectVirType(item.title, optionindex)}
                        key={optionindex}
                      >
                        <span className={classes.optiontitle}>
                          {item.title === 'Style Customization' && websiteEnv.isUnitedKingdom
                            ? 'Style Customisation'
                            : item.title}
                        </span>
                        <label className={classes.virtype}>{item.con}</label>
                      </div>
                    ) : null,
                  )}
                  {appointmentData.type ? <div className={classes.datetimecontent}>{datetimeModule}</div> : null}
                </div>
              ) : (
                <>
                  {!email ? (
                    <div className={classes.selectedinfo}>
                      <span className={classes.type}>{appointmentData.type}</span>
                      <span className={classes.date}>{appointmentData.date}</span>
                      <span className={classes.week}>{appointmentData.week},</span>
                      {isMobile ? <br /> : null}
                      <span className={classes.time}>{appointmentData.time}</span>
                      <span className={classes.timezone}>{appointmentData.timezone}</span>
                    </div>
                  ) : null}
                  {!completeStep2 ? (
                    <Image
                      className={classes.expandicon}
                      src={expand}
                      alt=''
                    />
                  ) : null}
                </>
              )}
            </div>
            <div className={classes.step}>
              <h5 className={classes.steptitle}>
                <i>2</i>
                <span>Your Information</span>
              </h5>
              {completeStep1 && !completeStep2 ? (
                <InformationForm
                  formDataId={formDataId}
                  appointmentData={appointmentData}
                  setCompleteStep2={setCompleteStep2}
                  setFormData={setFormData}
                  isUpdate={isUpdate}
                />
              ) : null}
            </div>
            <div className={classes.step}>
              <h5 className={classes.steptitle}>
                <i>3</i>
                <span>Confirmation</span>
              </h5>
              {completeStep2 ? (
                <div className={classes.allinfo}>
                  <div className={classes.appointment}>
                    <span>{formData?.appointmenttype}</span>
                  </div>
                  <div className={classes.appointmentdate}>
                    <span>{formData?.appointmentdate},</span>
                    <span>{formData?.appointmentweek},</span>
                    <span>{formData?.appointmenttime},</span>
                    <span>{formData?.timezone}</span>
                  </div>
                  <div className={classes.information}>
                    <span>{formData?.firstname}&nbsp;&nbsp;</span>
                    <span>{formData?.lastname}&nbsp;&nbsp;</span>
                    <span>{formData?.email}&nbsp;&nbsp;</span>
                  </div>

                  <div className={classes.primary}>
                    <a
                      className={classes.primarybtn}
                      onClick={() => canCelhandle()}
                    >
                      Cancel
                    </a>
                    <a
                      className={classes.primarybtn}
                      onClick={() => updateSubmit(formData?.id)}
                    >
                      Reschedule
                    </a>
                  </div>
                  <div className={classes.othertip}>
                    <p>Thank you so much for booking a virtual appointments with AW Bridal!</p>
                    <p>We will chat with you by phone.</p>
                    <p>Our phone number is (951) 305-0566.</p>
                    <p>Check your email for a confirmation. See you then!</p>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <InquiryAppointment canCelhandle={canCelhandle} />
        {canceldialog ? (
          <CancelDialog
            canCelhandle={canCelhandle}
            canCelSubmit={canCelSubmit}
            id={formData?.id}
          />
        ) : null}
      </div>
    </div>
  );
};

export default VirtualAppointments;
